"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combinedRequestService = combinedRequestService;

var _http = require("../lib/http");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function combinedRequestService(env, params, host) {
  var version = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'v1';
  var method = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'get';
  var http = (0, _http.setupCombinedApiRequest)(env, host);
  var url = "/".concat(version, "/combined_api/combined_api.").concat(method, "?version=1");
  return http.post(url, {
    _input: params
  }).then(function (_ref) {
    var data = _ref.data;
    var result = Object.keys(data).reduce(function (prev, current) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, current, data[current].data));
    }, {});
    return result;
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/@weike/services/lib/services/combined.js
// module id = 627
// module chunks = 4